import { StateService } from "./../_services/state.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { CourierService } from "../_services/courier.service";
import { State } from "../_models/state";

@Component({
  selector: "app-states-list-page",
  templateUrl: "./states-list-page.component.html",
  styleUrls: ["./states-list-page.component.scss"],
})
export class StatesListPageComponent implements OnInit {
  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    public courierService: CourierService,
    public stateService: StateService
  ) { }

  displayedColumns = ["Id", "Name", "CurrencyCode", "formatCourier", "formatActive"];
  dataSource: MatTableDataSource<State>;
  isDataLoaded = false;
  public couriers: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<State>();
    this.courierService.getCouriers().subscribe(
      (couriers) => {
        couriers.forEach((courier) => {
          this.couriers[courier.id] = courier.name;
        });
      },
      (err) => {
        this.showErrorMessage("Error retrieving couriers");
      }
    );
    this.stateService.getStates().subscribe(
      (states: State[]) => {
        this.dataSource.data = states.map((state) => {
          state.formatCourier = this.couriers[state.courierId];
          state.formatActive = state.active ? 'Active' : 'Inactive';
          return state;
        });
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataLoaded = true;
      },
      (err) => {
        if (err.status == 404) {
          this.dataSource.data = [];
        }
        this.isDataLoaded = true;
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addState() {
    this.router.navigate(["regional", "states", "add"]);
  }

  viewState(id: number) {
    this.router.navigate(["regional", "states", id]);
  }
}
